


// document.addEventListener("DOMContentLoaded", () => {

//   const section = document.getElementById("diamond-listing-section");

//   if (!section) return;

//   const API_URL = section.dataset.apiUrl;
// const SHOP = section.dataset.shop;
//   const loading = document.getElementById("diamond-loading");
//   const grid = document.getElementById("diamond-grid");
//   const pagination = document.getElementById("diamond-pagination");

//   let currentPage = 1;
//   const limit = 24;
//   let totalPages = 1;

//   loadDiamonds(currentPage);

//   async function loadDiamonds(page = 1) {

//     loading.style.display = "block";
//     loading.innerHTML = "Loading diamonds...";

//     grid.style.display = "none";
//     grid.innerHTML = "";

//     pagination.innerHTML = "";

//     // ---- TIMING START ----
//     const tStart = performance.now();
//     console.log(`%c[Diamonds] Starting fetch for page ${page} at`, "color:orange", new Date().toISOString());

//     try {

//       const tFetchStart = performance.now();

//  const response = await fetch(
//   `${API_URL}?page=${page}&limit=${limit}&shop=${encodeURIComponent(SHOP)}`
// );

//       const tFetchEnd = performance.now();
//       console.log(`%c[Diamonds] fetch() headers received in ${(tFetchEnd - tFetchStart).toFixed(2)} ms`, "color:cyan");

//       if (!response.ok) {
//         throw new Error("Failed to fetch diamonds");
//       }

//       const tJsonStart = performance.now();

//       const result = await response.json();

//       const tJsonEnd = performance.now();
//       console.log(`%c[Diamonds] response.json() parsed in ${(tJsonEnd - tJsonStart).toFixed(2)} ms`, "color:cyan");
//       console.log(`[Diamonds] Received ${result.data.length} records, total=${result.total}, totalPages=${result.totalPages}`);

//       currentPage = result.page;
//       totalPages = result.totalPages;

//       loading.style.display = "none";
//       grid.style.display = "grid";

//       const tRenderStart = performance.now();

//       renderCards(result.data);

//       const tRenderEnd = performance.now();
//       console.log(`%c[Diamonds] renderCards() DOM insert took ${(tRenderEnd - tRenderStart).toFixed(2)} ms`, "color:cyan");

//       renderPagination();

//       const tTotal = performance.now();
//       console.log(
//         `%c[Diamonds] TOTAL time from click/load to cards rendered: ${(tTotal - tStart).toFixed(2)} ms`,
//         "color:lime; font-weight:bold"
//       );
//       console.log(
//         `%c[Diamonds] Breakdown → network+server: ${(tFetchEnd - tFetchStart).toFixed(2)}ms | json parse: ${(tJsonEnd - tJsonStart).toFixed(2)}ms | DOM render: ${(tRenderEnd - tRenderStart).toFixed(2)}ms`,
//         "color:yellow"
//       );

//     } catch (error) {

//       console.error("[Diamonds] Failed to load:", error);

//       loading.innerHTML = "Failed to load diamonds.";

//     }

//   }

// //   function renderCards(diamonds) {
// //   grid.innerHTML = "";

// //   diamonds.forEach((diamond) => {
// //     const hasCompareAt =
// //       diamond.compare_at_price &&
// //       Number(diamond.compare_at_price) > Number(diamond.total_price);

// //     grid.insertAdjacentHTML(
// //       "beforeend",
// //       `
// //         <div class="diamond-card" data-stock="${diamond.stock_no}">
// //           <div class="diamond-image">
// //             ${hasCompareAt ? `<span class="diamond-badge">Sale</span>` : ""}
// //             <img
// //               src="${diamond.image_url}"
// //               alt="${diamond.shape}"
// //               loading="lazy"
// //               onerror="this.onerror=null; this.src='https://cdn.shopify.com/s/files/1/0823/5810/8395/files/images.png?v=1784969155';"
// //             >
// //           </div>
// //           <div class="diamond-info">
// //             <h3>${diamond.shape}</h3>
// //             <p class="diamond-specs">${diamond.weight} CT &middot; ${diamond.color} / ${diamond.clarity}</p>
// //             <div class="diamond-price">
// //               ${hasCompareAt ? `<span class="compare-at">$${diamond.compare_at_price}</span>` : ""}
// //               $${diamond.total_price}
// //             </div>
// //           </div>
// //         </div>
// //       `
// //     );
// //   });
// // }
// function renderCards(diamonds) {
//   grid.innerHTML = "";

//   diamonds.forEach((diamond) => {
//     const hasCompareAt =
//       diamond.compare_at_price &&
//       Number(diamond.compare_at_price) > Number(diamond.total_price);

//     let discountBadge = "";
//     if (hasCompareAt) {
//       const pct = Math.round(
//         ((Number(diamond.compare_at_price) - Number(diamond.total_price)) /
//           Number(diamond.compare_at_price)) *
//           100
//       );
//       discountBadge = `<span class="diamond-discount-badge">${pct}% OFF</span>`;
//     }

//     grid.insertAdjacentHTML(
//       "beforeend",
//       `
//         <div class="diamond-card" data-stock="${diamond.stock_no}">
//           <div class="diamond-image">
//             ${discountBadge}
//             <img
//               src="${diamond.image_url}"
//               alt="${diamond.shape}"
//               loading="lazy"
//               onerror="this.onerror=null; this.src='https://cdn.shopify.com/s/files/1/0823/5810/8395/files/images.png?v=1784969155';"
//             >
//           </div>
//           <div class="diamond-info">
//             <h3>${diamond.weight}ct ${diamond.shape}</h3>
//             <p class="diamond-specs">Colour: <b>${diamond.color}</b> | Clarity: <b>${diamond.clarity}</b> | Cut: <b>${diamond.cut || "-"}</b></p>
//             <div class="diamond-price">
//               ${hasCompareAt ? `<span class="compare-at">$${diamond.compare_at_price}</span>` : ""}
//               $${diamond.total_price}
//             </div>
//             <div class="diamond-meta">
        
//               ${diamond.lab ? `
// <span>
//   <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2l7 3v6c0 5-3.5 8.5-7 11-3.5-2.5-7-6-7-11V5l7-3z"/></svg>
//   ${diamond.lab} Certified
// </span>
// ` : ""}
//             </div>
//           </div>
//         </div>
//       `
//     );
//   });
// }
// function renderPagination() {

//   pagination.innerHTML = "";

//   const wrapper = document.createElement("div");
//   wrapper.className = "diamond-pagination-wrapper";

//   // Prev Button
//   const prevBtn = document.createElement("button");
//   prevBtn.className = "diamond-page-btn diamond-page-nav";
//   prevBtn.innerHTML = "Prev";
//   prevBtn.disabled = currentPage === 1;

//   prevBtn.addEventListener("click", () => {
//     if (currentPage > 1) {
//       loadDiamonds(currentPage - 1);
//     }
//   });

//   wrapper.appendChild(prevBtn);

//   // Build page number list with ellipsis
//   const pages = getPageList(currentPage, totalPages);

//   pages.forEach((p) => {
//     if (p === "...") {
//       const dots = document.createElement("span");
//       dots.className = "diamond-page-dots";
//       dots.innerHTML = "&hellip;";
//       wrapper.appendChild(dots);
//       return;
//     }

//     const pageBtn = document.createElement("button");
//     pageBtn.className = "diamond-page-btn";
//     pageBtn.innerHTML = p;

//     if (p === currentPage) {
//       pageBtn.classList.add("active");
//     }

//     pageBtn.addEventListener("click", () => {
//       if (p !== currentPage) {
//         loadDiamonds(p);
//       }
//     });

//     wrapper.appendChild(pageBtn);
//   });

//   // Next Button
//   const nextBtn = document.createElement("button");
//   nextBtn.className = "diamond-page-btn diamond-page-nav";
//   nextBtn.innerHTML = "Next";
//   nextBtn.disabled = currentPage >= totalPages;

//   nextBtn.addEventListener("click", () => {
//     if (currentPage < totalPages) {
//       loadDiamonds(currentPage + 1);
//     }
//   });

//   wrapper.appendChild(nextBtn);

//   pagination.appendChild(wrapper);

//   attachCardEvents();

// }

// function getPageList(current, total) {
//   const pages = [];

//   if (total <= 7) {
//     for (let i = 1; i <= total; i++) pages.push(i);
//     return pages;
//   }

//   pages.push(1);

//   if (current > 3) pages.push("...");

//   const start = Math.max(2, current - 1);
//   const end = Math.min(total - 1, current + 1);

//   for (let i = start; i <= end; i++) pages.push(i);

//   if (current < total - 2) pages.push("...");

//   pages.push(total);

//   return pages;
// }
// function attachCardEvents() {
//   document.querySelectorAll(".diamond-card").forEach((card) => {
//     card.addEventListener("click", async () => {
//       const stock = card.dataset.stock;

//       card.classList.add("is-loading");
//       showFullPageLoader();

//       const tClickStart = performance.now();

//       try {
//         const response = await fetch(
//           "https://diamondinventory.1digit.technology/api/shopify/select-diamond",
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               stock,
//               shop: SHOP,
//             }),
//           }
//         );

//         const result = await response.json();

//         const tClickEnd = performance.now();
//         console.log(`%c[Diamonds] select-diamond took ${(tClickEnd - tClickStart).toFixed(2)} ms`, "color:cyan");

//         if (!result.success) {
//           throw new Error(result.message);
//         }

//         window.location.href = result.url;
//       } catch (error) {
//         console.error(error);
//         alert("Failed to open diamond.");
//         card.classList.remove("is-loading");
//         hideFullPageLoader();
//       }
//     });
//   });
// }

// function showFullPageLoader() {
//   if (document.getElementById("diamond-fullpage-loader")) return;

//   const overlay = document.createElement("div");
//   overlay.id = "diamond-fullpage-loader";
//   overlay.className = "diamond-fullpage-loader";
//   overlay.innerHTML = `
//    <div class="diamond-spinner-circle"></div>
//     <p>Opening diamond...</p>
//   `;
//   document.body.appendChild(overlay);
// }

// function hideFullPageLoader() {
//   const overlay = document.getElementById("diamond-fullpage-loader");
//   if (overlay) overlay.remove();
// }
// });



document.addEventListener("DOMContentLoaded", () => {

  const section = document.getElementById("diamond-listing-section");

  if (!section) return;

  const API_URL = section.dataset.apiUrl;
  const SHOP = section.dataset.shop;
  const loading = document.getElementById("diamond-loading");
  const grid = document.getElementById("diamond-grid");
  const pagination = document.getElementById("diamond-pagination");
  const filterBar = document.getElementById("diamond-filter-bar");

  let currentPage = 1;
  const limit = 24;
  let totalPages = 1;

  const activeFilters = {
    shape: [],
    color: [],
    clarity: [],
    fluorescence: [],
    polish: [],
    symmetry: [],
    lab: [],
    weightMin: null,
    weightMax: null,
    tableMin: null,
    tableMax: null,
    depthMin: null,
    depthMax: null,
  };

  // const MULTI_FIELDS = ["shape", "color", "clarity", "fluorescence", "polish", "symmetry", "lab"];
  const MULTI_FIELDS = ["shape", "color", "clarity", "lab"];
  // const RANGE_FIELDS = [
  //   { key: "weight", label: "Carat Weight" },
  //   { key: "table", label: "Table %" },
  //   { key: "depth", label: "Depth %" },
  // ];
  const RANGE_FIELDS = [
  { key: "weight", label: "Carat Weight" },
];

  init();

  async function init() {
    if (filterBar) {
      await buildFilterBar();
    }
    loadDiamonds(currentPage);
  }

  function buildQueryString(page) {
    const params = new URLSearchParams();
    params.set("page", page);
    params.set("limit", limit);
    params.set("shop", SHOP);

    MULTI_FIELDS.forEach((field) => {
      if (activeFilters[field].length > 0) {
        params.set(field, activeFilters[field].join(","));
      }
    });

    RANGE_FIELDS.forEach(({ key }) => {
      const minVal = activeFilters[`${key}Min`];
      const maxVal = activeFilters[`${key}Max`];
      if (minVal !== null && minVal !== "") params.set(`${key}Min`, minVal);
      if (maxVal !== null && maxVal !== "") params.set(`${key}Max`, maxVal);
    });

    return params.toString();
  }

  async function loadDiamonds(page = 1) {

    loading.style.display = "block";
    loading.innerHTML = "Loading diamonds...";

    grid.style.display = "none";
    grid.innerHTML = "";

    pagination.innerHTML = "";

    try {

      const query = buildQueryString(page);
      const response = await fetch(`${API_URL}?${query}`);

      if (!response.ok) {
        throw new Error("Failed to fetch diamonds");
      }

      const result = await response.json();

      currentPage = result.page;
      totalPages = result.totalPages;

      loading.style.display = "none";
      grid.style.display = "grid";

const pageOffset = (currentPage - 1) * limit;
renderCards(result.data, pageOffset);
renderPagination();

    } catch (error) {
      console.error("[Diamonds] Failed to load:", error);
      loading.innerHTML = "Failed to load diamonds.";
    }

  }

  async function buildFilterBar() {

    const filtersApiUrl = filterBar.dataset.filtersApiUrl;
    let options = {};

    try {
      const res = await fetch(filtersApiUrl);
      const json = await res.json();
      if (json.success) options = json.options;
    } catch (err) {
      console.error("[Diamonds] Failed to load filter options:", err);
      return;
    }

    filterBar.innerHTML = "";

    // const fieldMap = {
    //   shape: { label: "Shape", values: options.shapes || [] },
    //   color: { label: "Color", values: options.colors || [] },
    //   clarity: { label: "Clarity", values: options.clarities || [] },
    //   fluorescence: { label: "Fluorescence", values: options.fluorescences || [] },
    //   polish: { label: "Polish", values: options.polishes || [] },
    //   symmetry: { label: "Symmetry", values: options.symmetries || [] },
    //   lab: { label: "Lab", values: options.labs || [] },
    // };
const labOrder = ["IGI", "GIA"];
    const sortedLabs = (options.labs || []).slice().sort(
      (a, b) => labOrder.indexOf(a) - labOrder.indexOf(b)
    );

    const shapeOrder = [
      "ROUND", "OVAL", "PEAR", "EMERALD", "MARQUISE",
      "CUSHION", "RADIANT", "HEART", "PRINCESS", "ASSCHER",
    ];
    const sortedShapes = (options.shapes || []).slice().sort((a, b) => {
      const ai = shapeOrder.indexOf(a);
      const bi = shapeOrder.indexOf(b);
      const aRank = ai === -1 ? shapeOrder.length : ai;
      const bRank = bi === -1 ? shapeOrder.length : bi;
      return aRank - bRank;
    });

const clarityOrder = ["VVS1", "VVS2", "VS1", "VS2", "SI1", "SI2"];
    const sortedClarities = (options.clarities || []).slice().sort((a, b) => {
      const ai = clarityOrder.indexOf(a);
      const bi = clarityOrder.indexOf(b);
      const aRank = ai === -1 ? clarityOrder.length : ai;
      const bRank = bi === -1 ? clarityOrder.length : bi;
      return aRank - bRank;
    });

    const fieldMap = {
      shape: { label: "Shape", values: sortedShapes },
      color: { label: "Color", values: options.colors || [] },
      clarity: { label: "Clarity", values: sortedClarities },
      lab: { label: "Lab", values: sortedLabs },
    };
//     MULTI_FIELDS.forEach((field) => {
//       const { label, values } = fieldMap[field];
//       if (values.length === 0) return;
//       filterBar.appendChild(createMultiDropdown(field, label, values));
//     });

//     // const rangeDefaults = {
//     //   weight: [options.weight_min, options.weight_max],
//     //   table: [options.table_min, options.table_max],
//     //   depth: [options.depth_min, options.depth_max],
//     // };
//     const rangeDefaults = {
//   weight: [options.weight_min, options.weight_max],
// };

//     RANGE_FIELDS.forEach(({ key, label }) => {
//       filterBar.appendChild(createRangeDropdown(key, label, rangeDefaults[key]));
//     });
const rangeDefaults = {
      weight: [options.weight_min, options.weight_max],
    };

    // Shape first
    if (fieldMap.shape.values.length > 0) {
      filterBar.appendChild(createMultiDropdown("shape", fieldMap.shape.label, fieldMap.shape.values));
    }

    // Weight right after Shape
    filterBar.appendChild(createRangeDropdown("weight", "Carat Weight", rangeDefaults.weight));

    // Then remaining multi-select fields (color, clarity, lab)
    ["color", "clarity", "lab"].forEach((field) => {
      const { label, values } = fieldMap[field];
      if (values.length === 0) return;
      filterBar.appendChild(createMultiDropdown(field, label, values));
    });
    const clearBtn = document.createElement("button");
    clearBtn.className = "diamond-filter-clear";
    clearBtn.innerHTML = "Clear All";
    clearBtn.addEventListener("click", () => {
      MULTI_FIELDS.forEach((f) => (activeFilters[f] = []));
      RANGE_FIELDS.forEach(({ key }) => {
        activeFilters[`${key}Min`] = null;
        activeFilters[`${key}Max`] = null;
      });
      buildFilterBar();
      loadDiamonds(1);
    });
    filterBar.appendChild(clearBtn);

    document.addEventListener("click", (e) => {
      document.querySelectorAll(".diamond-filter-dropdown.open").forEach((dd) => {
        if (!dd.contains(e.target)) dd.classList.remove("open");
      });
    });

  }

  function createMultiDropdown(field, label, values) {

    const dropdown = document.createElement("div");
    dropdown.className = "diamond-filter-dropdown";

    const selectedCount = activeFilters[field].length;

    const btn = document.createElement("button");
    btn.className = "diamond-filter-btn" + (selectedCount > 0 ? " has-value" : "");
    btn.innerHTML = `${label}${selectedCount > 0 ? ` (${selectedCount})` : ""} <span class="arrow">&#9662;</span>`;

    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const wasOpen = dropdown.classList.contains("open");
      document.querySelectorAll(".diamond-filter-dropdown.open").forEach((dd) => dd.classList.remove("open"));
      if (!wasOpen) dropdown.classList.add("open");
    });

    const panel = document.createElement("div");
    panel.className = "diamond-filter-panel";

    values.forEach((val) => {
      const row = document.createElement("label");
      row.className = "diamond-filter-checkbox-row";

      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.value = val;
      checkbox.checked = activeFilters[field].includes(val);

      checkbox.addEventListener("change", () => {
        if (checkbox.checked) {
          activeFilters[field].push(val);
        } else {
          activeFilters[field] = activeFilters[field].filter((v) => v !== val);
        }
        btn.className = "diamond-filter-btn" + (activeFilters[field].length > 0 ? " has-value" : "");
        btn.innerHTML = `${label}${activeFilters[field].length > 0 ? ` (${activeFilters[field].length})` : ""} <span class="arrow">&#9662;</span>`;
        loadDiamonds(1);
      });

      row.appendChild(checkbox);
      row.appendChild(document.createTextNode(val));
      panel.appendChild(row);
    });

    dropdown.appendChild(btn);
    dropdown.appendChild(panel);

    return dropdown;
  }

  function createRangeDropdown(key, label, defaults) {

    const [defMin, defMax] = defaults;

    const dropdown = document.createElement("div");
    dropdown.className = "diamond-filter-dropdown";

    const hasValue = activeFilters[`${key}Min`] !== null || activeFilters[`${key}Max`] !== null;

    const btn = document.createElement("button");
    btn.className = "diamond-filter-btn" + (hasValue ? " has-value" : "");
    btn.innerHTML = `${label} <span class="arrow">&#9662;</span>`;

    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const wasOpen = dropdown.classList.contains("open");
      document.querySelectorAll(".diamond-filter-dropdown.open").forEach((dd) => dd.classList.remove("open"));
      if (!wasOpen) dropdown.classList.add("open");
    });

    const panel = document.createElement("div");
    panel.className = "diamond-filter-panel";

    const row = document.createElement("div");
    row.className = "diamond-filter-range-row";

    const minInput = document.createElement("input");
    minInput.type = "number";
    minInput.step = "0.01";
    minInput.placeholder = defMin !== undefined ? `Min (${defMin})` : "Min";
    minInput.value = activeFilters[`${key}Min`] ?? "";

    const dash = document.createElement("span");
    dash.innerHTML = "&ndash;";

    const maxInput = document.createElement("input");
    maxInput.type = "number";
    maxInput.step = "0.01";
    maxInput.placeholder = defMax !== undefined ? `Max (${defMax})` : "Max";
    maxInput.value = activeFilters[`${key}Max`] ?? "";

    row.appendChild(minInput);
    row.appendChild(dash);
    row.appendChild(maxInput);

    const applyBtn = document.createElement("button");
    applyBtn.className = "diamond-filter-apply-btn";
    applyBtn.innerHTML = "Apply";
    applyBtn.addEventListener("click", () => {
      activeFilters[`${key}Min`] = minInput.value !== "" ? minInput.value : null;
      activeFilters[`${key}Max`] = maxInput.value !== "" ? maxInput.value : null;

      const applied = activeFilters[`${key}Min`] !== null || activeFilters[`${key}Max`] !== null;
      btn.className = "diamond-filter-btn" + (applied ? " has-value" : "");

      dropdown.classList.remove("open");
      loadDiamonds(1);
    });

    panel.appendChild(row);
    panel.appendChild(applyBtn);

    dropdown.appendChild(btn);
    dropdown.appendChild(panel);

    return dropdown;
  }

let nextRefillOffset = 0;

  function renderCards(diamonds, pageOffset) {
    grid.innerHTML = "";
    nextRefillOffset = pageOffset + diamonds.length;

    diamonds.forEach((diamond) => {
      appendCard(diamond);
    });
  }

  function appendCard(diamond) {
    const hasCompareAt =
      diamond.compare_at_price &&
      Number(diamond.compare_at_price) > Number(diamond.total_price);

    let discountBadge = "";
    if (hasCompareAt) {
      const pct = Math.round(
        ((Number(diamond.compare_at_price) - Number(diamond.total_price)) /
          Number(diamond.compare_at_price)) *
          100
      );
      discountBadge = `<span class="diamond-discount-badge">${pct}% OFF</span>`;
    }

    const cardHtml = `
      <div class="diamond-card" data-stock="${diamond.stock_no}">
        <div class="diamond-image">
          ${discountBadge}
          <img
            src="${diamond.image_url}"
            alt="${diamond.shape}"
            loading="lazy"
          >
        </div>
        <div class="diamond-info">
          <h3>${diamond.weight}ct ${diamond.shape}</h3>
          <p class="diamond-specs">Colour: <b>${diamond.color}</b> | Clarity: <b>${diamond.clarity}</b> | Cut: <b>${diamond.cut || "-"}</b></p>
          <div class="diamond-price">
            ${hasCompareAt ? `<span class="compare-at">$${diamond.compare_at_price}</span>` : ""}
            $${diamond.total_price}
          </div>
          <div class="diamond-meta">
            ${diamond.lab ? `
<span>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2l7 3v6c0 5-3.5 8.5-7 11-3.5-2.5-7-6-7-11V5l7-3z"/></svg>
  ${diamond.lab} Certified${diamond.certificate_no ? ` #${diamond.certificate_no}` : ""}
</span>
` : ""}
          </div>
        </div>
      </div>
    `;

    grid.insertAdjacentHTML("beforeend", cardHtml);

    const cardEl = grid.lastElementChild;
    const imgEl = cardEl.querySelector("img");

    imgEl.addEventListener("error", () => {
      cardEl.remove();
      fetchOneReplacement();
    });

    attachSingleCardEvent(cardEl);
  }

  async function fetchOneReplacement() {
    try {
      const params = new URLSearchParams();
      params.set("offset", nextRefillOffset);
      params.set("limit", 1);
      params.set("shop", SHOP);

      MULTI_FIELDS.forEach((field) => {
        if (activeFilters[field].length > 0) {
          params.set(field, activeFilters[field].join(","));
        }
      });
      RANGE_FIELDS.forEach(({ key }) => {
        const minVal = activeFilters[`${key}Min`];
        const maxVal = activeFilters[`${key}Max`];
        if (minVal !== null && minVal !== "") params.set(`${key}Min`, minVal);
        if (maxVal !== null && maxVal !== "") params.set(`${key}Max`, maxVal);
      });

      const response = await fetch(`${API_URL}?${params.toString()}`);
      const result = await response.json();

      nextRefillOffset += 1;

      if (result.data && result.data.length > 0) {
        appendCard(result.data[0]);
      }
    } catch (err) {
      console.error("[Diamonds] Failed to fetch replacement:", err);
    }
  }

  function attachSingleCardEvent(card) {
    card.addEventListener("click", async () => {
      const stock = card.dataset.stock;

      card.classList.add("is-loading");
      showFullPageLoader();

      try {
        const response = await fetch(
          "https://diamondapi.dvikjewels.com/api/shopify/select-diamond",
          // "https://diamondinventory.1digit.technology/api/shopify/select-diamond",
          // "https://diamond-backend-production-20d6.up.railway.app/api/shopify/select-diamond",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ stock, shop: SHOP }),
          }
        );

        const result = await response.json();

        if (!result.success) {
          throw new Error(result.message);
        }

        window.location.href = result.url;
      } catch (error) {
        console.error(error);
        alert("Failed to open diamond.");
        card.classList.remove("is-loading");
        hideFullPageLoader();
      }
    });
  }
  function renderPagination() {

    pagination.innerHTML = "";

    const wrapper = document.createElement("div");
    wrapper.className = "diamond-pagination-wrapper";

    const prevBtn = document.createElement("button");
    prevBtn.className = "diamond-page-btn diamond-page-nav";
    prevBtn.innerHTML = "Prev";
    prevBtn.disabled = currentPage === 1;
    prevBtn.addEventListener("click", () => {
      if (currentPage > 1) loadDiamonds(currentPage - 1);
    });
    wrapper.appendChild(prevBtn);

    const pages = getPageList(currentPage, totalPages);

    pages.forEach((p) => {
      if (p === "...") {
        const dots = document.createElement("span");
        dots.className = "diamond-page-dots";
        dots.innerHTML = "&hellip;";
        wrapper.appendChild(dots);
        return;
      }

      const pageBtn = document.createElement("button");
      pageBtn.className = "diamond-page-btn";
      pageBtn.innerHTML = p;
      if (p === currentPage) pageBtn.classList.add("active");
      pageBtn.addEventListener("click", () => {
        if (p !== currentPage) loadDiamonds(p);
      });
      wrapper.appendChild(pageBtn);
    });

    const nextBtn = document.createElement("button");
    nextBtn.className = "diamond-page-btn diamond-page-nav";
    nextBtn.innerHTML = "Next";
    nextBtn.disabled = currentPage >= totalPages;
    nextBtn.addEventListener("click", () => {
      if (currentPage < totalPages) loadDiamonds(currentPage + 1);
    });
    wrapper.appendChild(nextBtn);

pagination.appendChild(wrapper);

  }

  function getPageList(current, total) {
    const pages = [];
    if (total <= 7) {
      for (let i = 1; i <= total; i++) pages.push(i);
      return pages;
    }
    pages.push(1);
    if (current > 3) pages.push("...");
    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);
    for (let i = start; i <= end; i++) pages.push(i);
    if (current < total - 2) pages.push("...");
    pages.push(total);
    return pages;
  }

  function attachCardEvents() {
    document.querySelectorAll(".diamond-card").forEach((card) => {
      card.addEventListener("click", async () => {
        const stock = card.dataset.stock;

        card.classList.add("is-loading");
        showFullPageLoader();

        try {
          const response = await fetch(
            "https://diamondapi.dvikjewels.com/api/shopify/select-diamond",
            // "https://diamondinventory.1digit.technology/api/shopify/select-diamond",
            // "https://diamond-backend-production-20d6.up.railway.app/api/shopify/select-diamond",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ stock, shop: SHOP }),
            }
          );

          const result = await response.json();

          if (!result.success) {
            throw new Error(result.message);
          }

          window.location.href = result.url;
        } catch (error) {
          console.error(error);
          alert("Failed to open diamond.");
          card.classList.remove("is-loading");
          hideFullPageLoader();
        }
      });
    });
  }

  function showFullPageLoader() {
    if (document.getElementById("diamond-fullpage-loader")) return;
    const overlay = document.createElement("div");
    overlay.id = "diamond-fullpage-loader";
    overlay.className = "diamond-fullpage-loader";
    overlay.innerHTML = `
      <div class="diamond-spinner-circle"></div>
      <p>Opening diamond...</p>
    `;
    document.body.appendChild(overlay);
  }

  function hideFullPageLoader() {
    const overlay = document.getElementById("diamond-fullpage-loader");
    if (overlay) overlay.remove();
  }

});